export const maxWidthMobile = '767px';
